import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RequireAuth } from "./components/RequireAuth";
import { AppShell } from "./components/layout/AppShell";
import Login from "./pages/Login";
import Home from "./pages/Home";
import HealthCheck from "./pages/HealthCheck";
import SagaList from "./pages/SagaList";
import SagaDetail from "./pages/SagaDetail";
import SagaNew from "./pages/SagaNew";
import SagaDefinitionList from "./pages/SagaDefinitionList";
import SagaDefinitionNew from "./pages/SagaDefinitionNew";
import SagaDefinitionDetail from "./pages/SagaDefinitionDetail";
import TenantList from "./pages/TenantList";
import TenantDetail from "./pages/TenantDetail";
import OnboardingNew from "./pages/OnboardingNew";
import AICredentialsPage from "./pages/AICredentials";
import AIInvocationsPage from "./pages/AIInvocations";
import GlobalSagaVariablesPage from "./pages/GlobalSagaVariables";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<RequireAuth />}>
          <Route element={<AppShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/health" element={<HealthCheck />} />
            <Route path="/sagas" element={<SagaList />} />
            <Route path="/sagas/new" element={<SagaNew />} />
            {/* SPEC-20260507-0136 (Fase 3): saga-definitions composer.
                Routes mais específicas devem vir antes da `/sagas/:id` (UUID). */}
            <Route path="/sagas/definitions" element={<SagaDefinitionList />} />
            <Route path="/sagas/definitions/new" element={<SagaDefinitionNew />} />
            <Route path="/sagas/definitions/:name" element={<SagaDefinitionDetail />} />
            <Route path="/sagas/:id" element={<SagaDetail />} />
            <Route path="/tenants" element={<TenantList />} />
            <Route path="/tenants/:tenantKey" element={<TenantDetail />} />
            <Route path="/onboardings/new" element={<OnboardingNew />} />
            <Route path="/admin/ai-credentials" element={<AICredentialsPage />} />
            <Route path="/admin/ai-invocations" element={<AIInvocationsPage />} />
            <Route path="/admin/saga-variables" element={<GlobalSagaVariablesPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
